<div class="ds-avatar" 
  [ngClass]="{
    'avatar-sm': size === 'sm',
    'avatar-md': size === 'md',
    'avatar-lg': size === 'lg'
  }">
  <img class="ds-avatar-img" *ngIf="image" [src]="image" alt="{{name}} profile picture" [title]="name" />
  <div class="ds-avatar-initials" [title]="name">{{ getInitials(name) }}</div>
</div>